<main-layout [sidebarLayout]="sidebarLayout" site="spotter">
	<router-outlet></router-outlet>
	
	<ng-template #sidebarContent>
		<!-- Spotter app store links -->
		<div class="app-store-links">
			<a href="http://www.projectseagrass.org/" target="_blank"><img class="app-store" src="/spotter-shared/assets/global-images/projectseagrass.png"></a>
	
			<a href="https://itunes.apple.com/gb/app/seagrass-spotter/id1122588337?mt=8" target="_blank" class="app-store-link-container">
				<fa-icon [icon]="['fab', 'apple']"></fa-icon>
				<p [innerHTML]="'global.menu_items.app_store'|translate">Download on the <span>App Store</span></p>
			</a>
	
			<a href="https://play.google.com/store/apps/details?id=org.seagrassspotter.seagrassspotter" target="_blank" class="app-store-link-container">
				<fa-icon [icon]="['fab', 'google-play']"></fa-icon>
				<p [innerHTML]="'global.menu_items.google_play'|translate">Download on the <span>App Store</span></p>
			</a>
		</div>
	</ng-template>
</main-layout>

<ng-template #filterCanvas let-offcanvas>
	<filter></filter>Add commentMore actions
</ng-template>